import { useTranslation } from 'react-i18next';
import FormField from '@/components/FormField/FormField';
import TitleText from '@/components/atoms/TitleText';
import InfoText from '@/components/atoms/InfoText';
import { useFormContext } from 'react-hook-form';
import { DollarCircle } from 'iconsax-react';

const PricingTradeForm = () => {
  const { t: t } = useTranslation();
  const { watch } = useFormContext();

  const productType = watch('productType') || 'cart';

  return (
    <div
      id="pricingTrade"
      className="bg-white dark:bg-dark-surface-primary p-4 md:p-6 rounded-2xl border border-light-input-border dark:border-dark-input-border shadow-sm mb-8 animate-fade-in"
      data-testid="pricing-trade-form"
    >
      <div
        className="mb-6 flex gap-4 items-center"
        data-testid="pricing-trade-header"
      >
        <div
          className="p-3 bg-soft-background dark:bg-dark-button-bg-secondary rounded-xl text-neutral-900 dark:text-dark-text-primary flex items-center justify-center"
          data-testid="pricing-trade-icon-container"
        >
          <DollarCircle variant="Bold" size={24} />
        </div>
        <div data-testid="pricing-trade-header-text">
          <TitleText
            text={t('pricingTrade')}
            size="lg"
            className="!font-bold !text-[18px] text-[#090909] dark:text-dark-text-primary !leading-[100%] !tracking-[0px]"
          />
          <InfoText
            text={t('pricingTradeSubTitle')}
            size="xs"
            className="!font-normal !text-[12px] text-[#777777] dark:text-dark-text-secondary !leading-[100%] !tracking-[0px] mt-1"
          />
        </div>
      </div>

      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-6"
        data-testid="pricing-trade-fields-container"
      >
        <FormField
          name="minQty"
          id="minQty"
          type="number"
          min={1}
          max={productType === 'cart' ? 5 : undefined}
          maxLength={5}
          labelClassName="!font-semibold"
          label={t('moqLabel')}
          placeholder={t('moqPlaceholder')}
          data-testid="moq-field"
        />

        <FormField
          name="leadTime"
          id="leadTime"
          type="number"
          min={1}
          max={100}
          maxLength={4}
          labelClassName="!font-semibold"
          label={t('leadTimeLabel')}
          placeholder={t('leadTimePlaceholder')}
          data-testid="lead-time-field"
        />
      </div>
    </div>
  );
};

export default PricingTradeForm;
